import { put, select } from 'redux-saga/effects';
import { setDirtyState } from 'data/templates';
import { TemplateObjectType, TemplatesAPI } from 'data/templates/api';
import { addUpdateTemplateDraftIndexedDb } from 'hooks/use-idb';
import { denormalizePayload } from '../api/transform';
import { getDocumentTemplateStore } from '../selectors';
import type { DocumentTemplate, DocumentTemplateStore } from '../types';

const getTemplateId = (path: string) => {
  const id = path.split('/')[3];
  const isTemplateUrl = path.startsWith('/templates');
  const isNewTemplate = id === 'new';
  /**
   * /templates/projects/:id/
   * /templates/documents/:id/
   */
  const templateId = Number.isFinite(parseInt(id, 10))
    ? parseInt(id, 10)
    : null;

  if (!isTemplateUrl) {
    return null;
  }
  if (isNewTemplate) {
    return 'new';
  }
  if (templateId) {
    return templateId;
  }

  return null;
};

export function* saveDocumentTemplate(
  docId: number,
  sync?: boolean,
): Generator {
  const payloadToNormalize = (yield select(
    getDocumentTemplateStore(docId as number),
  )) as ValueOf<DocumentTemplateStore>;

  const id = getTemplateId(window.location.pathname);

  if (payloadToNormalize) {
    const denormalizedDocumentTemplate = denormalizePayload(payloadToNormalize);

    if (sync) {
      const payload = yield TemplatesAPI.save<DocumentTemplate>(
        denormalizedDocumentTemplate,
      );

      if (id != null) {
        yield put(
          setDirtyState({
            id,
            _state: false,
          }),
        );
      }

      return payload;
    }

    if (id != null) {
      yield put(
        setDirtyState({
          id,
          _state: true,
        }),
      );
    }

    // whenever a store update is made for document updates, it should be saved in idb as well
    yield addUpdateTemplateDraftIndexedDb(
      parseInt(String(docId), 10),
      denormalizedDocumentTemplate,
      TemplateObjectType.Document,
    );

    return denormalizedDocumentTemplate;
  }

  return null;
}
